import { GuideUploadOptions, uploadGuideMedia } from '../../../../api/stays-guide-client';
import { StaysApiError } from '../../../../api/stays-client';
import type { GuideMedia } from '../../../../interfaces/stays-guide';
import { CompressImageError, compressImage } from '../../../../utils/compress-image';
import { refusalText } from '../../dashboard/dashboard-stays-components/stays-labels';

/**
 * ONE GUIDE PHOTO, COMPRESSED ON THE DEVICE AND SENT (plan S7.8): every photo
 * surface of the editor (the fixed slots, the gallery, a tip's photo) goes
 * through here, so they compress alike and refuse alike.
 */

export type MediaUpdate = (update: (current: GuideMedia[]) => GuideMedia[]) => void;

export const ACCEPT_PHOTOS = 'image/jpeg,image/png,image/webp';

export const uploadCompressed = async (
  listingId: string,
  file: File,
  opts: GuideUploadOptions,
  onProgress?: (percent: number) => void
): Promise<GuideMedia> => {
  const ready = await compressImage(file);
  const { media } = await uploadGuideMedia(listingId, ready, opts, onProgress);

  return media;
};

/** The words a failed upload shows: the compressor's, the server's field
 *  sentence, the server's code sentence, or a plain fallback. */
export const uploadErrorText = (err: unknown): string => {
  if (err instanceof CompressImageError) return err.message;
  const e = err as StaysApiError;
  if (e && e.fields && typeof e.fields.image === 'string' && e.fields.image) return e.fields.image;

  return refusalText(e, 'Could not upload the photo. Try again.');
};
